// «Claves del perfil»: conceptos del perfil buscado a partir de campos estructurados.
// Son CONTEXTO para el planner; nunca queries literales. Espejo de prospecting.profile_keys.
const withOther = (list, other) => [
  ...(list || []).filter((x) => x && x !== "Otro"),
  ...((list || []).includes("Otro") && (other || "").trim() ? [other.trim()] : []),
];

export function profileSectors(avatar) {
  const secs = withOther(avatar?.sectors, avatar?.sector_other);
  if (secs.length) return secs;
  return String(avatar?.sector || "").split(",").map((s) => s.trim()).filter(Boolean);
}

export function deriveProfileKeys(avatar, brain, limit = 6) {
  const keys = [];
  const add = (v) => {
    const t = String(v || "").replace(/\s+/g, " ").trim();
    if (t && !keys.some((k) => k.toLowerCase() === t.toLowerCase())) keys.push(t);
  };
  withOther(avatar?.person_types, avatar?.person_type_other).forEach(add);
  profileSectors(avatar).forEach(add);
  // v20: perfiles propuestos por la IA: su identidad buscable (o su nombre) antes que la descripción («Profesionales que…»).
  if (!keys.length) (avatar?.searchable_identity || []).slice(0, 3).forEach(add);
  if (!keys.length && avatar?.generated && avatar?.name) add(avatar.name);
  // Perfiles antiguos sin estructura: solo la parte identitaria de la descripción ("Consultores y coaches que…" -> "Consultores y coaches").
  if (!keys.length && avatar?.description) add(String(avatar.description).split(":").pop().split(/\s+que\s+|[,.;(]/i)[0]);
  add(avatar?.location || brain?.market || "");
  return keys.slice(0, limit);
}
